import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormComponentsModule } from '@shared/components/form/form-components.module';
import { ProvinciaComuneComponent } from './components/provincia-comune/provincia-comune.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IsNilOrEmptyPipe } from './pipes/is-nil-or-empty.pipe';
import { FormControlPipe } from '@shared/pipes/form-control.pipe';
import { ToNumPipe } from '@shared/pipes/to-num.pipe';
import { ToFormGroupPipe } from '@shared/pipes/to-form-group.pipe';
import { GetBooleanValuePipe } from '@shared/pipes/get-boolean-value.pipe';
import { ValidationErrorsBtnComponent } from '@shared/components/validation-errors-btn/validation-errors-btn.component';
import { NavLinkStatusBtnComponent } from '@shared/components/nav-link-status-btn/nav-link-status-btn.component';

@NgModule({
    declarations: [
        ProvinciaComuneComponent,
        IsNilOrEmptyPipe,
        FormControlPipe,
        ToNumPipe,
        ToFormGroupPipe,
        GetBooleanValuePipe,
        ValidationErrorsBtnComponent,
        NavLinkStatusBtnComponent,
    ],
    exports: [
        FormComponentsModule,
        ProvinciaComuneComponent,
        IsNilOrEmptyPipe,
        FormControlPipe,
        ToNumPipe,
        ToFormGroupPipe,
        GetBooleanValuePipe,
        ValidationErrorsBtnComponent,
        NavLinkStatusBtnComponent,
    ],
    imports: [CommonModule, RouterModule, FormComponentsModule, ReactiveFormsModule],
})
export class SharedModule {}
